const BRL = new Intl.NumberFormat("pt-BR", {
  style: "currency",
  currency: "BRL",
});

export function formatBRL(cents) {
  const value = (cents ?? 0) / 100;
  return BRL.format(value);
}

const DATE = new Intl.DateTimeFormat("pt-BR", {
  day: "2-digit",
  month: "short",
});

export function formatDate(iso) {
  if (!iso) return null;
  return DATE.format(new Date(iso));
}

export function daysUntil(iso) {
  if (!iso) return null;
  const now = new Date();
  const target = new Date(iso);
  const diff = target.getTime() - now.getTime();
  return Math.max(0, Math.ceil(diff / (1000 * 60 * 60 * 24)));
}
